import { reactive } from 'vue';

/**
 * LA NOUVELLE DEMANDE EST UNE MODALE, ouverte d'où qu'on soit : déposer une
 * demande ne doit pas faire perdre l'écran en cours (la file, une fiche
 * client). Une seule modale, montée dans App.vue ; les boutons et le menu ne
 * font que l'ouvrir.
 *
 * L'adresse `/nouvelle-demande` reste valable (favoris, liens anciens, menu) :
 * le routeur ouvre la modale au lieu d'afficher un écran.
 */
const etat = reactive({ ouverte: false, periodique: false });

export function useNouvelleDemande() {
  return {
    etat,
    /** `periodique` : ouvre la modale avec la règle de périodicité déjà cochée. */
    ouvrir(options: { periodique?: boolean } = {}): void {
      etat.periodique = options.periodique ?? false;
      etat.ouverte = true;
    },
    fermer(): void {
      etat.ouverte = false;
    },
  };
}
